export default __webpack_public_path__ + "0c3a85f5bbab390c2a116db2631e8081.svg";